/**
 * 课程
 * 课程API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import OssStsAkVo from '../../oss/model/OssStsAkVo';
  /**
   * Oss service.
   * @module oss/api/OssApi
   * @version 0.2.0
   */

  /**
   * Constructs a new OssApi. 
   * @alias module:oss/api/OssApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 获取oss访问令牌
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:oss/model/OssStsAkVo}
     */
this.getStsAk = function() {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = OssStsAkVo;
      return this.apiClient.callApi(
        '/api/oss/get_sts_ak', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 通用获取oss访问令牌
     * @param {String} path 上传目录
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:oss/model/OssStsAkVo}
     */
this.getStsAkColumn = function(path) {
      var postBody = null;

      // verify the required parameter 'path' is set
      if (path == undefined || path == null) {
        throw "Missing the required parameter 'path' when calling getStsAkColumn";
      }


      var pathParams = {
      };
      var queryParams = {
        'path': path
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = OssStsAkVo;
      return this.apiClient.callApi(
        '/api/oss/get_sts_ak_column', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 通用获取oss访问令牌
     * @param {String} path 上传目录
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:oss/model/OssStsAkVo}
     */
this.getStsAkTextbookEditor = function(path) {
      var postBody = null;

      // verify the required parameter 'path' is set
      if (path == undefined || path == null) {
        throw "Missing the required parameter 'path' when calling getStsAkTextbookEditor";
      }


      var pathParams = {
      };
      var queryParams = {
        'path': path
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = OssStsAkVo;
      return this.apiClient.callApi(
        '/api/oss/get_sts_ak/textbook_editor', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 通用获取oss访问令牌
     * @param {String} path 上传目录
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:oss/model/OssStsAkVo}
     */
this.getStsAkV2 = function(path) {
      var postBody = null;

      // verify the required parameter 'path' is set
      if (path == undefined || path == null) {
        throw "Missing the required parameter 'path' when calling getStsAkV2";
      }


      var pathParams = {
      };
      var queryParams = {
        'path': path
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = OssStsAkVo;
      return this.apiClient.callApi(
        '/api/oss/get_sts_ak_v2', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
